var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-2",attrs:{"data-event-list":""}},[(_vm.size(_vm.events) > 1)?_c('div',{attrs:{"data-event-list":""}}):_c('event-list',{attrs:{"data-event-list":"","location_link":"false","item":_vm.first(_vm.events),"path":{
                data:'event_data'
            }}})],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bed3dafc","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/pages/account/AccountEvent.vue
// module id = D+JS
// module chunks = 0